(function () {
  'use strict';

  var root = document.querySelector('[data-pack-builder]');
  var dataEl = document.getElementById('AwitaPackData');
  if (!root || !dataEl) return;

  var DATA = JSON.parse(dataEl.textContent);
  var CUPS = {};
  DATA.cups.forEach(function (c) { CUPS[c.key] = c; });

  // shape key "n350-n530" -> pack id
  var SHAPES = { '2-0': 'duo350', '1-1': 'mixto', '0-2': 'duoGo', '2-1': 'trio', '2-2': 'family' };
  var MAX_PER_SIZE = 2;
  var MAX_SLOTS = 4;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var els = {
    step: root.querySelector('[data-builder-step]'),
    slots: root.querySelector('[data-builder-slots]'),
    picker: root.querySelector('[data-builder-picker]'),
    packname: root.querySelector('[data-builder-packname]'),
    price: root.querySelector('[data-builder-price]'),
    compare: root.querySelector('[data-builder-compare]'),
    save: root.querySelector('[data-builder-save]'),
    hint: root.querySelector('[data-builder-hint]'),
    cta: root.querySelector('[data-builder-cta]')
  };

  var state = {
    slots: [null, null], // cup keys or null
    active: 0,           // slot index being picked, or -1
    shownPrice: 0
  };

  function money(n) {
    return '$' + Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function counts(excludeIdx) {
    var c = { '350': 0, '530': 0 };
    state.slots.forEach(function (key, i) {
      if (key && i !== excludeIdx) c[CUPS[key].size]++;
    });
    return c;
  }

  function filledCount() {
    return state.slots.filter(Boolean).length;
  }

  function currentShape() {
    if (state.slots.some(function (k) { return !k; })) return null;
    var c = counts(-1);
    return SHAPES[c['350'] + '-' + c['530']] || null;
  }

  // ordered color selections for variant matching
  function selections() {
    var c350 = [], c530 = [];
    state.slots.forEach(function (key) {
      if (!key) return;
      var cup = CUPS[key];
      (cup.size === '350' ? c350 : c530).push(cup.name);
    });
    return { c350: c350, c530: c530 };
  }

  var ORDER530 = ['Solmenta', 'Fresiluz'];

  function pair530(s) {
    var a = s.c530.slice().sort(function (x, y) {
      return ORDER530.indexOf(x) - ORDER530.indexOf(y);
    });
    return a[0] + ' y ' + a[1];
  }

  function optsForShape(shape) {
    var s = selections();
    if (shape === 'duo350') return [s.c350[0], s.c350[1]];
    if (shape === 'mixto') return [s.c350[0], s.c530[0]];
    if (shape === 'duoGo') return [s.c530[0], s.c530[1]];
    if (shape === 'trio') return [s.c350[0], s.c350[1], s.c530[0]];
    if (shape === 'family') return [s.c350[0], s.c350[1], pair530(s)];
    return null;
  }

  function findVariant(shape) {
    var pack = DATA.packs[shape];
    var opts = optsForShape(shape);
    if (!pack || !opts) return null;
    for (var i = 0; i < pack.variants.length; i++) {
      var v = pack.variants[i];
      var match = true;
      for (var j = 0; j < opts.length; j++) {
        if (v.opts[j] !== opts[j]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  /* ---------- rendering ---------- */

  function slotCard(key, i) {
    if (key) {
      var cup = CUPS[key];
      return '<div class="awita-builder__slot awita-builder__slot--filled' + (state.active === i ? ' is-active' : '') + '" data-slot="' + i + '" style="--awita-slot-tint:' + cup.tint + '">' +
        '<button type="button" class="awita-builder__slot-main" data-slot-edit="' + i + '" aria-label="Cambiar vaso ' + (i + 1) + '">' +
          '<span class="awita-builder__slot-media"><img src="' + cup.img + '" alt="Vaso ' + cup.size + 'ml ' + cup.name + '" loading="lazy"></span>' +
          '<span class="awita-builder__slot-name">' + cup.name + '</span>' +
          '<span class="awita-builder__slot-size">' + cup.size + ' ml</span>' +
        '</button>' +
        '<button type="button" class="awita-builder__slot-remove" data-slot-remove="' + i + '" aria-label="Quitar vaso ' + (i + 1) + '">&times;</button>' +
      '</div>';
    }
    return '<div class="awita-builder__slot awita-builder__slot--empty' + (state.active === i ? ' is-active' : '') + '" data-slot="' + i + '">' +
      '<button type="button" class="awita-builder__slot-main" data-slot-edit="' + i + '" aria-label="Elegir vaso ' + (i + 1) + '">' +
        '<span class="awita-builder__slot-plus" aria-hidden="true">?</span>' +
        '<span class="awita-builder__slot-name">Vaso ' + (i + 1) + '</span>' +
      '</button>' +
    '</div>';
  }

  function ghostCard() {
    var c = counts(-1);
    var canAdd = state.slots.length < MAX_SLOTS && filledCount() === state.slots.length &&
      (c['350'] < MAX_PER_SIZE || c['530'] < MAX_PER_SIZE);
    if (!canAdd) return '';
    return '<div class="awita-builder__slot awita-builder__slot--ghost">' +
      '<button type="button" class="awita-builder__slot-main" data-slot-add aria-label="Agregar otro vaso">' +
        '<span class="awita-builder__slot-plus" aria-hidden="true">+</span>' +
        '<span class="awita-builder__slot-name">Agregar</span>' +
      '</button>' +
    '</div>';
  }

  function renderSlots() {
    var html = '';
    state.slots.forEach(function (key, i) { html += slotCard(key, i); });
    html += ghostCard();
    els.slots.innerHTML = html;
  }

  function renderPicker() {
    var c = counts(state.active);
    var groups = [
      { size: '350', label: 'Vasos 350 ml · desde los 6 meses' },
      { size: '530', label: 'Vasos 530 ml Hot & Cold · desde los 24 meses' }
    ];
    var html = '';
    groups.forEach(function (g) {
      var full = c[g.size] >= MAX_PER_SIZE;
      html += '<div class="awita-builder__group' + (full ? ' is-disabled' : '') + '">';
      html += '<p class="awita-builder__group-title">' + g.label + (full ? ' <span class="awita-builder__group-note">(ya tienes 2)</span>' : '') + '</p>';
      html += '<div class="awita-builder__cups">';
      DATA.cups.filter(function (cup) { return cup.size === g.size; }).forEach(function (cup, idx) {
        var selected = state.slots[state.active] === cup.key;
        html += '<button type="button" class="awita-builder__cup' + (selected ? ' is-selected' : '') + '" data-pick="' + cup.key + '"' +
          (full && !selected ? ' disabled' : '') +
          ' style="--awita-cup-tint:' + cup.tint + '; --awita-cup-delay:' + (idx * 45) + 'ms">' +
          '<span class="awita-builder__cup-media"><img src="' + cup.img + '" alt="Vaso ' + cup.size + 'ml ' + cup.name + '" loading="lazy"></span>' +
          '<span class="awita-builder__cup-name">' + cup.name + '</span>' +
        '</button>';
      });
      html += '</div></div>';
    });
    els.picker.innerHTML = html;
  }

  function tweenPrice(el, from, to) {
    if (reduceMotion || from === to) { el.textContent = money(to); return; }
    var start = null, dur = 350;
    function frame(t) {
      if (!start) start = t;
      var p = Math.min((t - start) / dur, 1);
      p = 1 - Math.pow(1 - p, 3);
      el.textContent = money(from + (to - from) * p);
      if (p < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  function renderBar() {
    var filled = filledCount();
    var shape = currentShape();
    els.hint.hidden = true;
    els.hint.innerHTML = '';

    if (shape) {
      var pack = DATA.packs[shape];
      var variant = findVariant(shape);
      var price = pack.price / 100;
      var compare = pack.compare / 100;
      els.packname.textContent = '¡Armaste el ' + pack.title + '!';
      els.price.hidden = false;
      tweenPrice(els.price, state.shownPrice || price, price);
      state.shownPrice = price;
      els.compare.hidden = false;
      els.compare.textContent = money(compare);
      els.save.hidden = false;
      els.save.textContent = 'Ahorras ' + money(compare - price);
      if (variant && variant.available) {
        els.cta.disabled = false;
        els.cta.textContent = 'Agregar mi pack · ' + money(price);
        els.cta.dataset.variant = variant.id;
        root.classList.add('is-complete');
        return;
      }
      els.cta.disabled = true;
      els.cta.textContent = 'Combinación agotada';
      root.classList.remove('is-complete');
      return;
    }

    root.classList.remove('is-complete');
    els.price.hidden = true;
    els.compare.hidden = true;
    els.save.hidden = true;
    els.cta.disabled = true;
    state.shownPrice = 0;

    if (filled < 2) {
      els.packname.textContent = 'Arma tu pack de 2 a 4 vasos';
      els.cta.textContent = 'Elige al menos 2 vasos';
      return;
    }

    // filled but not a valid shape (e.g. 1x350 + 2x530)
    var c = counts(-1);
    els.packname.textContent = 'Vas bien…';
    els.hint.hidden = false;
    if (c['350'] === 1 && c['530'] === 2) {
      els.hint.textContent = 'Agrega otro vaso 350 para formar el Family Pack.';
    } else {
      els.hint.textContent = 'Completa los vasos que faltan para formar tu pack.';
    }
    els.cta.textContent = 'Completa tu pack';
  }

  function renderStep() {
    var firstEmpty = state.slots.indexOf(null);
    if (state.active >= 0) {
      els.step.textContent = 'Elige tu vaso ' + (state.active + 1);
    } else if (firstEmpty >= 0) {
      els.step.textContent = 'Elige tu vaso ' + (firstEmpty + 1);
    } else if (currentShape()) {
      els.step.textContent = '¿Sumas otro vaso o vamos al carrito?';
    } else {
      els.step.textContent = 'Ajusta tu combinación';
    }
  }

  function render() {
    renderSlots();
    renderPicker();
    renderBar();
    renderStep();
  }

  /* ---------- events ---------- */

  root.addEventListener('click', function (e) {
    var t = e.target.closest('button');
    if (!t) return;

    if (t.hasAttribute('data-slot-edit')) {
      state.active = parseInt(t.getAttribute('data-slot-edit'), 10);
      render();
      return;
    }

    if (t.hasAttribute('data-slot-remove')) {
      var idx = parseInt(t.getAttribute('data-slot-remove'), 10);
      if (state.slots.length > 2) {
        state.slots.splice(idx, 1);
      } else {
        state.slots[idx] = null;
      }
      state.active = state.slots.indexOf(null);
      render();
      return;
    }

    if (t.hasAttribute('data-slot-add')) {
      state.slots.push(null);
      state.active = state.slots.length - 1;
      render();
      var pickerTop = els.picker.getBoundingClientRect().top + window.scrollY - 120;
      if (!reduceMotion) window.scrollTo({ top: pickerTop, behavior: 'smooth' });
      return;
    }

    if (t.hasAttribute('data-pick')) {
      var key = t.getAttribute('data-pick');
      var target = state.active;
      if (target < 0 || target >= state.slots.length) target = state.slots.indexOf(null);
      if (target >= 0) {
        state.slots[target] = key;
      } else {
        var cc = counts(-1);
        var size = CUPS[key].size;
        if (state.slots.length < MAX_SLOTS && cc[size] < MAX_PER_SIZE) {
          state.slots.push(key);
        }
      }
      state.active = state.slots.indexOf(null);
      render();
      return;
    }

    if (t.hasAttribute('data-builder-cta') && !t.disabled && t.dataset.variant) {
      t.disabled = true;
      t.textContent = 'Agregando…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(t.dataset.variant, 10), quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart');
        window.location.href = '/cart';
      }).catch(function () {
        t.disabled = false;
        t.textContent = 'Reintentar';
      });
    }
  });

  render();
})();
